import React, { useMemo, useState } from "react";
import { useStepNavigate } from "../hooks/useStepNavigate";
import { useOrder } from "../context/OrderContext";
import { useOrderSave } from "../context/OrderSaveContext";
import { useStaticOptions } from "../context/StaticOptionsContext";
import TablerLayout from "../components/layout/TablerLayout";
import StepperNavButton from "../components/stepper/StepperNavButton";
import { showErrorToast, showSuccessToast } from "../components/toasts/ToastService";

const mapMidsoleColor = (item, index) => {
    const rmelimidsolecolors_szam = (item && item.rmelimidsolecolors_szam) || 1;
    const label = (item && item.rmelimidsolecolors_sole_color_national) || "Ismeretlen (hiba!)";

    return { value: rmelimidsolecolors_szam, label };
};

const Koztalp = () => {
    const { order, updateOrder } = useOrder();
    const navigate = useStepNavigate();
    const { staticOptions } = useStaticOptions();
    const { saveOrder } = useOrderSave();
    const [loading, setLoading] = useState(false);

    const colors = useMemo(function () {
        const list = (staticOptions && staticOptions.midsole_colors) || [];
        return list
            .map(mapMidsoleColor)
            .filter(function (c) {
                return c.value !== 1 && c.label !== "";
            })
            .sort(function (a, b) {
                return a.label.localeCompare(b.label, "hu");
            });
    }, [staticOptions]);

    const [selectedColor, setSelectedColor] = useState(
        order.hmeliorder.hmeliorder_sole_color_national ? String(order.hmeliorder.hmeliorder_sole_color_national) : ""
    );

    const handleColorSelect = function (color) {

        setSelectedColor(color.value);
        updateOrder({
            ...order,
            hmeliorder: {
                    ...order.hmeliorder,
                    hmeliorder_sole_color_id: color.value,
                    hmeliorder_sole_color_national: color.label,
                },
        });
    };

    const handleBack = function () {
        navigate("/Talp");
    };

    const handleNext = async () => {
        if (!canProceed) {
            showErrorToast("Kérem, válasszon köztalp színt!");
            return;
        }

        try {
            setLoading(true);
            const result = await saveOrder(order);

            if (result && result.success) {
                showSuccessToast("A rendelés sikeresen mentve!");
                navigate("/Rama");
            } else {
                showErrorToast((result && result.message) || "Hiba történt a rendelés mentésekor!");
            }
        } catch (error) {
            console.error("Köztalp mentési hiba:", error);
            showErrorToast("Hiba történt a rendelés mentésekor!");
        } finally {
            setLoading(false);
        }
    };

    const canProceed = Boolean(selectedColor);

    return (
        <TablerLayout title="Köztalp szín kiválasztása">
            <div className="row justify-content-center">
                <div className="col-md-10">

                    <div className="card-body">
                        {colors.length === 0 ? (
                            <div className="alert alert-warning mb-0">
                                Nem érkezett köztalp szín adat a midsole_colors listából.
                            </div>
                        ) : (
                            <div className="row g-3">
                                {colors.map(function (color) {
                                    const isSelected = selectedColor === color.value;

                                    return (
                                        <div className="col-12 col-sm-6 col-md-4" key={color.value}>
                                            <button
                                                type="button"
                                                className={
                                                    "btn w-100 py-3 fw-semibold " +
                                                    (isSelected ? "btn-primary" : "btn-outline-primary text-primary border-primary bg-white")
                                                }
                                                style={{
                                                fontSize: 18,
                                                fontWeight: 600,
                                                borderWidth: 2,
                                                minHeight: 60,
                                                }}
                                                onClick={function () {
                                                    handleColorSelect(color);
                                                }}
                                            >
                                                {color.label}
                                            </button>
                                        </div>
                                    );
                                })}
                            </div>
                        )}
                    </div>

                    <div className="card-footer d-flex justify-content-between">
                        <StepperNavButton side="left" label="Vissza" onClick={handleBack} />
                        <StepperNavButton
                            side="right"
                            label="Tovább"
                            onClick={handleNext}
                            disabled={!canProceed || loading}
                        />
                    </div>
                </div>
            </div>
        </TablerLayout>
    );
};

export default Koztalp;